<div
  class="service-selection flex-1"
  [attr.data-testid]="'service-selection-segment-id-' + flightOrBound.id"
  [attr.data-boundid]="flightOrBound.id"
>
  <ng-container [ngSwitch]="state$ | async">
    <!-- CASE 1/3: SHOW LOADING INDICATOR -->
    <fcom-loader *ngSwitchCase="SelectionState.LOADING" [loaderType]="LoaderTheme.EMBEDDED" />

    <!-- CASE 2/3: SHOW SERVICE OPTIONS -->
    <ng-container *ngSwitchCase="SelectionState.HAS_SERVICES">
      <fcom-notification
        *ngIf="showSportNotification$ | async"
        class="block pr-medium-b"
        [theme]="NotificationTheme.WARNING"
        data-testid="sport-notification"
      >
        {{ 'ancillaries.baggage.sportEquipmentNotIncluded' | finLocalization }}
      </fcom-notification>
      <fcom-notification
        *ngFor="let notification of notifications$ | async; let last = last"
        [attr.data-testid]="'service-notification-' + notification.theme"
        [class.pr-medium-b]="last"
        [class.pr-xxsmall-b]="!last"
        [theme]="notification.theme"
        [iconName]="notification.iconName"
      >
        <span *ngIf="notification.key | finHasLocalizationKey">
          {{ notification.key | finLocalization }}
        </span>
        <span *ngIf="notification.reason">
          {{ notification.reason.key | finLocalization: notification.reason.data }}
        </span>
      </fcom-notification>

      <ng-container *ngIf="(blockingNotifications$ | async).length === 0">
        <fin-additional-info *ngIf="additionalText" [additionalInfoKey$]="additionalText | finToObservable" />

        <fin-tab-header [tabGroupId]="serviceTabGroupId" [startWith$]="initialTravelerIdSelected$" data-hj-suppress>
          <fin-tab-label
            *ngFor="let iterable of travelersAndServices$ | async"
            [tabId]="iterable.traveler.id"
            [title]="'-'"
            [subTitle]="iterable.traveler.firstName + ' ' + iterable.traveler.lastName"
            [checked]="iterable.hasServiceSelected$ | async"
          />
        </fin-tab-header>

        <div [formGroup]="form" class="pr-small-b">
          <fin-tab-group
            [tabGroupId]="serviceTabGroupId"
            class="block white-bg border-left border-right border-bottom rounded-bottom-large"
          >
            <fin-tab *ngFor="let iterable of travelersAndServices$ | async" [tabId]="iterable.traveler.id">
              <fin-ancillary-selection
                [groupedServices]="iterable.combinedGroupedServices"
                [showRemove]="!!form.controls[iterable.traveler.id].controls['radio']"
                [hideSelection]="iterable.services.length === 0"
                [ancillaries]="iterable.selectedServices$ | async"
                [serviceToVariantTierPricesMap]="
                  (travelerToServiceVariantTierPricesMap$ | async)?.get(iterable.traveler.id)
                "
                [isHighlightedServicesAvailable]="isHighlightedServicesAvailable"
                (removeSelections)="
                  removeSelections(
                    $event,
                    iterable.traveler.id,
                    flightOrBound.id,
                    iterable.useConfirmModalBeforeSelectionRemoval
                  )
                "
              />

              <div *ngIf="iterable.filters.length > 0" class="pr-small-x">
                <div *ngIf="iterable.filters.length > 1">
                  <fcom-chip
                    *ngFor="let filter of iterable.filters; let last = last"
                    class="inline-block mr-small-b"
                    [class.ms-xsmall-r]="!last"
                    [text]="'ancillaries.filters.' + filter + '.text' | finLocalization"
                    [title]="'ancillaries.filters.' + filter + '.ariaText' | finLocalization"
                    [theme]="(iterable.selectedFilter$ | async) === filter ? ChipTheme.ACTIVE : ChipTheme.DEFAULT"
                    (tagClicked)="iterable.selectedFilter$.next(filter)"
                  />
                </div>
                <div
                  *ngIf="iterable.filters.length === 1"
                  [class.pr-small-b]="(iterable.selectedFilter$ | async) !== 'none'"
                >
                  <button
                    class="font-body-1 nordic-blue-900-text underline"
                    data-testid="special-diet-toggle"
                    *ngIf="iterable.selectedFilter$ | async as filter"
                    (click)="
                      filter !== 'none' ? iterable.selectedFilter$.next('none') : iterable.selectedFilter$.next('all')
                    "
                  >
                    {{
                      filter === 'none'
                        ? ('ancillaries.show.specialDiet' | finLocalization)
                        : ('ancillaries.hide.specialDiet' | finLocalization)
                    }}
                  </button>
                </div>
              </div>
              <div class="rounded-bottom-large pr-small pr-clear-t" [formGroup]="form.controls[iterable.traveler.id]">
                <div class="services">
                  <fcom-notification
                    data-testid="pax-no-services-notification"
                    *ngIf="iterable.services.length === 0 && (iterable.selectedFilter$ | async) !== 'none'"
                  >
                    {{ 'ancillaries.noServicesForPax' | finLocalization }}
                  </fcom-notification>

                  @if ((passengersWithBundles$ | async).includes(iterable.traveler.id)) {
                    <fcom-notification
                      data-testid="bundle-already-selected-notification"
                      class="ps-small-y border-top"
                      [theme]="NotificationTheme.INFO"
                    >
                      {{ 'ancillaries.bundle.serviceIncludedInBundleNotification' | finLocalization }}
                    </fcom-notification>
                  }

                  <ng-container *ngFor="let service of iterable.services; let last = last">
                    <div
                      *ngIf="
                        (service.subCategory === (iterable.selectedFilter$ | async) ||
                          (iterable.selectedFilter$ | async) === 'all') &&
                        service.category !== Category.SEAT_WIFI
                      "
                      class="service block border rounded-large white-bg overflow-hidden"
                      [class.mr-xsmall-b]="!last"
                      [class.product-selected]="service.selected$ | async"
                    >
                      <input
                        *ngIf="service.inputType === 'radio'"
                        [id]="service.globalId + '-field'"
                        [attr.aria-describedby]="service.globalId + '-label'"
                        type="radio"
                        [value]="service.variant"
                        [attr.name]="flightOrBound.id + '-' + iterable.traveler.id"
                        [formControlName]="'radio'"
                        [attr.disabled]="
                          (passengersWithBundles$ | async).includes(iterable.traveler.id) ||
                          (service.quota$ | finMap: 'type' | async) === QuotaType.NO ||
                          service.showBlockingNotification ||
                          (service.paxLevelQuotaReached$ | async) ||
                          (service.paidQuantity !== 0 &&
                            (service.totalPrice?.amount !== '0' || service.subCategory !== SubCategory.SPECIAL_DIET))
                            ? 'disabled'
                            : undefined
                        "
                        (click)="clickInput($event, service, flightOrBound.id, iterable.traveler.id)"
                        class="is-vishidden"
                        data-testid="product-input"
                      />
                      <input
                        *ngIf="service.inputType === 'checkbox'"
                        [id]="service.globalId + '-field'"
                        [attr.aria-describedby]="service.globalId + '-label'"
                        type="checkbox"
                        [value]="service.variant"
                        [attr.name]="flightOrBound.id + '-' + iterable.traveler.id"
                        [formControlName]="service.variant"
                        [attr.disabled]="
                          (passengersWithBundles$ | async).includes(iterable.traveler.id) ||
                          (service.quota$ | finMap: 'type' | async) === QuotaType.NO ||
                          service.showBlockingNotification ||
                          (service.paxLevelQuotaReached$ | async) ||
                          (service.paidQuantity !== 0 && service.totalPrice?.amount !== '0')
                            ? 'disabled'
                            : undefined
                        "
                        (click)="clickInput($event, service, flightOrBound.id, iterable.traveler.id)"
                        class="is-vishidden"
                        data-testid="product-input"
                      />
                      <label
                        #label
                        [class.hidden]="service.inputType === 'number'"
                        [attr.for]="service.globalId + '-field'"
                        [attr.aria-labelledby]="service.globalId + '-label'"
                      ></label>
                      <div class="flex service-container">
                        <fin-content-image
                          *ngIf="service.media"
                          class="flex-1 flex--basis0 relative"
                          [fillParent]="(aspectRatio$ | async) === '1x1'"
                          [scale]="false"
                          [imageData$]="service.media | finToObservable"
                          [aspectRatio$]="aspectRatio$"
                        />
                        <div
                          class="flex-1 flex--basis0 flex flex--column flex--space-between ps-medium nordic-blue-900-text font-body-1"
                        >
                          <div
                            class="flex"
                            [ngClass]="{
                              'flex--column flex--space-between grow':
                                service.media || (this.isTabletDown$ | async) === true,
                            }"
                          >
                            <div
                              [ngClass]="{
                                'flex-2 flex--basis0': !service.media && (this.isTabletDown$ | async) !== true,
                              }"
                            >
                              <div [id]="service.globalId + '-label'">
                                <h3 class="font-heading-5">
                                  {{ service.translations.title }}
                                </h3>
                                <div class="flex flex--middle ps-xxsmall-t">
                                  @if (service.originalPrice) {
                                    <span
                                      class="font-body-2 strike-through"
                                      data-testid="product-selection-original-price"
                                    >
                                      {{
                                        service.originalPrice
                                          | finPrice
                                            : {
                                                roundPrice:
                                                  service.originalPrice && service.originalPrice.amount === '0',
                                              }
                                      }}
                                    </span>
                                  }
                                  @if (
                                    !!(travelerToServiceVariantTierPricesMap$ | async)
                                      ?.get(iterable.traveler.id)
                                      ?.get(service.variant) === false
                                  ) {
                                    <div class="flex flex--middle">
                                      <span
                                        class="service-price flex-1 font-heading-5 heather-700-text"
                                        [class.ps-xxsmall-l]="service.originalPrice"
                                        data-testid="product-selection-total-price"
                                      >
                                        {{
                                          service.totalPrice
                                            | finPrice
                                              : { roundPrice: service.totalPrice && service.totalPrice.amount === '0' }
                                        }}
                                      </span>
                                      @if (service.totalPoints) {
                                        <span
                                          class="font-body-1 medium-type ps-xxsmall-l flex flex--middle"
                                          data-testid="product-selection-avios-price"
                                        >
                                          /
                                          <fcom-icon
                                            class="icon-small ms-xxsmall-x"
                                            [name]="SvgLibraryIcon.AVIOS_CURRENCY"
                                          />
                                          {{ service.totalPoints.amount | finPoints }}
                                          {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
                                        </span>
                                      }
                                    </div>
                                  }
                                </div>

                                @if (service.originalPrice) {
                                  <fcom-tag data-testid="product-selection-product-tag" [theme]="TagTheme.POPULAR">
                                    <fcom-icon class="icon-small" [name]="SvgLibraryIcon.DISCOUNT_BLOCK" />
                                    <span class="ms-xxsmall-l">{{
                                      (isPersonalizedMealOffer ? 'campaign.personalizedMealOffer' : 'campaign.badge')
                                        | finLocalization
                                    }}</span>
                                  </fcom-tag>
                                }
                              </div>

                              <div class="ms-medium-y">
                                <div
                                  class="service-description"
                                  *ngIf="service.category !== Category.MEAL"
                                  [innerHTML]="service.translations.description"
                                ></div>
                              </div>
                            </div>
                            <ng-container
                              *ngIf="
                                !service.showBlockingNotification &&
                                [QuotaType.FREE, QuotaType.SELECTED].includes(service.quota$ | finMap: 'type' | async)
                              "
                            >
                              <div
                                class="selection-container fill flex--self-end"
                                [ngClass]="{
                                  'ps-large-l flex-1 flex--basis0':
                                    !service.media && (this.isTabletDown$ | async) !== true,
                                  'ps-small-t': service.media || (this.isTabletDown$ | async) !== true,
                                }"
                              >
                                @if (service.inputType === 'number') {
                                  <fin-plus-minus-selector
                                    *finLet="
                                      (travelerToServiceVariantTierPricesMap$ | async)
                                        .get(iterable.traveler.id)
                                        ?.get(service.variant) as variantTieredPrice
                                    "
                                    [attr.data-testid]="'minus-plus-' + service.globalId"
                                    [min]="service.minNumberItems"
                                    [max]="
                                      (service.paxLevelQuotaReached$ | async)
                                        ? +form.controls[iterable.traveler.id].controls[service.variant].value
                                        : service.maxNumberItems - service.paidQuantity
                                    "
                                    [title]="
                                      'ancillaries.piece'
                                        | finPluralLocalization
                                          : +form.controls[iterable.traveler.id].controls[service.variant].value
                                    "
                                    [description]="
                                      variantTieredPrice?.accumulatedPrice ?? (service.displayTotalPrice$ | async)
                                        | finPrice
                                    "
                                    [priceDescription]="
                                      variantTieredPrice?.currentProductPrice
                                        ? {
                                            text:
                                              (+form.controls[iterable.traveler.id].controls[service.variant].value ===
                                              0
                                                ? 'productSelection.tierPrice.addProduct.'
                                                : 'productSelection.tierPrice.nextProduct.') + service.variant
                                              | finLocalization,
                                            price: variantTieredPrice.currentProductPrice,
                                            points: variantTieredPrice.currentProductPriceAsPoints,
                                          }
                                        : null
                                    "
                                    [model]="+form.controls[iterable.traveler.id].controls[service.variant].value"
                                    [decreaseLabel]="
                                      'ancillaries.state.remove'
                                        | finLocalization: { product: service.translations.title }
                                    "
                                    [increaseLabel]="
                                      'ancillaries.state.add' | finLocalization: { product: service.translations.title }
                                    "
                                    [controls]="service.globalId + '-label'"
                                    (increment)="addQuantity(service, flightOrBound.id, iterable.traveler.id)"
                                    (decrement)="removeQuantity(service, flightOrBound.id, iterable.traveler.id)"
                                  />
                                }
                                <fcom-button
                                  *ngIf="service.inputType !== 'number'"
                                  (clickBtn)="label.click()"
                                  [attr.data-testid]="'select-button-' + service.globalId + '-button'"
                                  [removeFromNavigation]="true"
                                  [text]="service.buttonText$ | async"
                                  [disabled]="
                                    (passengersWithBundles$ | async).includes(iterable.traveler.id) ||
                                    (service.paidQuantity !== 0 &&
                                      (service.totalPrice?.amount !== '0' ||
                                        service.subCategory !== SubCategory.SPECIAL_DIET)) ||
                                    (service.paxLevelQuotaReached$ | async)
                                  "
                                  [mode]="ButtonMode.FILL"
                                  [theme]="
                                    (service.selected$ | async)
                                      ? ButtonTheme.LIGHT_SECONDARY_OUTLINE
                                      : ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE
                                  "
                                  [icon]="
                                    (service.selected$ | async) === true
                                      ? {
                                          name: SvgLibraryIcon.CHECKMARK,
                                          position: IconPosition.LEFT,
                                        }
                                      : undefined
                                  "
                                />
                              </div>
                            </ng-container>
                          </div>

                          <fcom-notification
                            class="ps-small-t"
                            *ngIf="
                              (service.quota$ | finMap: 'type' | async) === QuotaType.TOPPED &&
                              CONFIG[category]?.toppedQuotaKey
                            "
                            [theme]="NotificationTheme.ALERT"
                          >
                            {{ CONFIG[category].toppedQuotaKey | finLocalization }}
                          </fcom-notification>
                          <fcom-notification
                            class="ps-small-t"
                            *ngIf="
                              (service.quota$ | finMap: 'type' | async) === QuotaType.NO &&
                              CONFIG[category]?.noQuotaLeftKey
                            "
                            [theme]="NotificationTheme.WARNING"
                          >
                            {{ CONFIG[category].noQuotaLeftKey | finLocalization }}
                          </fcom-notification>
                        </div>
                      </div>
                      <fcom-notification
                        data-testid="pax-quota-notification"
                        class="ps-small border-top"
                        *ngIf="service.paxLevelQuotaReached$ | async"
                        [theme]="NotificationTheme.WARNING"
                      >
                        {{ 'ancillaries.quota.paxQuotaReached' | finLocalization }}
                      </fcom-notification>
                      <fcom-notification
                        class="ps-small border-top"
                        *ngIf="
                          service.paidQuantity > 0 &&
                          (service.totalPrice?.amount !== '0' || service.subCategory !== SubCategory.SPECIAL_DIET) &&
                          service.inputType !== 'number'
                        "
                        [attr.data-testid]="'service-notification-paid-' + service.globalId"
                      >
                        {{ CONFIG[category]?.alreadyPurchased | finLocalization }}
                      </fcom-notification>
                      <fcom-notification
                        data-testid="block-service-notification"
                        class="ps-small border-top"
                        *ngIf="service.showBlockingNotification && CONFIG[category].blockSelectionNotification"
                        [theme]="NotificationTheme.ALERT"
                      >
                        {{ CONFIG[category].blockSelectionNotification | finLocalization }}
                      </fcom-notification>

                      <ng-container *ngIf="!service.showBlockingNotification && service.quota$ | async as quota">
                        <fcom-notification
                          class="ps-small border-top"
                          *ngIf="
                            quota.count !== undefined &&
                            quota.count < 9 &&
                            quota.type === QuotaType.FREE &&
                            CONFIG[category]?.quotaLimitKey
                          "
                          [theme]="NotificationTheme.WARNING"
                        >
                          {{ CONFIG[category].quotaLimitKey | finLocalization: { quota: quota.count } }}
                        </fcom-notification>
                      </ng-container>
                      <fin-product-expand
                        *ngIf="
                          (service.category === Category.MEAL && service.translations.description) ||
                          service.translations.ingredients
                        "
                        [title]="'ancillaries.meals.showDetails' | finLocalization"
                      >
                        <fin-meal-details [meal]="service" />
                      </fin-product-expand>
                      <fin-product-expand
                        *ngIf="
                          'ancillaries.' + service.category + '.' + service.variant + '.moreAbout.article.url'
                            | finHasLocalizationKey
                        "
                        [title]="
                          'ancillaries.' + service.category + '.' + service.variant + '.moreAbout.title'
                            | finLocalization
                        "
                      >
                        <cms-unstyled-fragment
                          [contentUrl$]="
                            'ancillaries.' + service.category + '.' + service.variant + '.moreAbout.article.url'
                              | finLocalization
                              | finToObservable
                          "
                          [showTitle]="false"
                        />
                      </fin-product-expand>
                    </div>
                  </ng-container>
                  @if (iterable.additionalInfoBlockNotification) {
                    <fcom-notification
                      class="ps-xlarge-t"
                      [theme]="NotificationTheme.INFO"
                      data-testid="additional-info-block-notification"
                    >
                      <span [innerHTML]="iterable.additionalInfoBlockNotification | finLocalization"></span>
                    </fcom-notification>
                  }
                  @if (iterable.additionalInfoBlockUrl | finLocalization; as contentUrl) {
                    <ng-container
                      [ngTemplateOutlet]="additionalInfoBlockUrl"
                      [ngTemplateOutletContext]="{ contentUrl$: contentUrl | finToObservable }"
                    />
                  }
                </div>
              </div>
            </fin-tab>
          </fin-tab-group>
        </div>
      </ng-container>
    </ng-container>

    <!-- CASE 3/3: SHOW NO-SERVICE MESSAGE -->
    <div *ngSwitchCase="SelectionState.NO_SERVICES" class="flex flex--basis0 flex--column">
      <fcom-notification
        *ngFor="let notification of notifications$ | async; let last = last"
        data-testid="no-service-notification"
        [class.pr-medium-b]="last"
        [class.pr-xxsmall-b]="!last"
        [theme]="notification.theme"
        [iconName]="notification.iconName"
      >
        @if (notification.key | finHasLocalizationKey) {
          <span [innerHTML]="notification.key | finLocalization | finSafe: 'html'"></span>
        } @else {
          <span [innerHTML]="'services.cannotAdd' | finLocalization | finSafe: 'html'"></span>
        }

        @if (notification.reason) {
          <span [innerHTML]="notification.reason.key | finLocalization: notification.reason.data"></span>
        }
      </fcom-notification>
    </div>
  </ng-container>
</div>

<ng-template #additionalInfoBlockUrl let-contentUrl$="contentUrl$">
  <section class="service-description mr-medium-t" data-testid="common-product-service-description">
    <cms-unstyled-fragment [contentUrl$]="contentUrl$" class="block" />
  </section>
</ng-template>
